import React, {useState} from 'react';
import {IModule} from "../../../../models/IModule";
import {EnumModuleTypes} from "../../../../enums/EnumModuleTypes";
import styles from './AdministrationModuleComponent.module.css'
import Buttons, {EnumColors} from "../../../../components/Utils/Buttons/Buttons/Buttons";
import {EnumLanguage} from "../../../../enums/EnumLanguage";
import {UIText} from "../../../../enums/UIText/UIText";
import AdministrationModuleRow from "./AdministrationModuleRow/AdministrationModuleRow";
import {DragDropContext, Draggable, Droppable, DropResult} from 'react-beautiful-dnd'
import {useAppDispatch} from "../../../../hooks/redux";
import {modulesSlice} from "../../../../store/reducers/ModulesSlice";
import {updateOrdersModulesThunk} from "../../../../store/actions/ModulesActions";
import ModalPortal from "../../../../Portals/ModalPortal";
import EditModule from "../EditModule/EditModule";
import {EnumFog} from "../../../../components/Utils/FogContainer/FogContainer";

interface IProps {
    modules: IModule[],
    modulesType: EnumModuleTypes,
    title: string
}

const AdministrationModuleComponent = ({modules, modulesType, title}: IProps) => {

    const dispatch = useAppDispatch()

    const handlerOnDragEnd = (result: DropResult) => {
        const items = Array.from(modules)
        const [reorderedItem] = items.splice(result.source.index, 1);

        if (result.destination) {
            items.splice(result.destination.index, 0, reorderedItem);
            const newOrderItems = items.map((module, index) => {
                return {...module, order: index + 1}
            })

            if (modulesType === EnumModuleTypes.basic) {
                dispatch(modulesSlice.actions.setBasicModules(newOrderItems))
            }

            if (modulesType === EnumModuleTypes.additional) {
                dispatch(modulesSlice.actions.setAdditionalModules(newOrderItems))
            }

            const arrayIdAndOrder = newOrderItems.map((module) => {
                return {id: module.id, order: module.order}
            })

            dispatch(updateOrdersModulesThunk(arrayIdAndOrder))


        }

    }

    const [isOpenEditModule, setIsOpenEditModule] = useState<boolean>(false)


    return (
        <div className={styles.wrapper}>

            <div className={styles.header}>
                <h3>{title}</h3>
                <Buttons
                    className={styles.buttonAdd}
                    color={EnumColors.white}
                    onClick={() => setIsOpenEditModule(true)}
                >
                    {UIText.actions.add[EnumLanguage.ru]}
                </Buttons>
            </div>

            <ModalPortal options={{
                setStateModal: setIsOpenEditModule,
                fogPower: EnumFog.strong,
                statusModal: isOpenEditModule
            }}>

                <EditModule type={modulesType} setIsOpenEditModule={setIsOpenEditModule}/>
            </ModalPortal>

            <DragDropContext onDragEnd={(result, provided) => handlerOnDragEnd(result)}>
                <Droppable droppableId={modulesType}>
                    {(provided) => (
                        <div className={styles.modulesWrapper} {...provided.droppableProps} ref={provided.innerRef}>
                            {
                                modules.map((module: IModule, index) => (
                                    <Draggable key={`${modulesType}_${module.id}`} draggableId={`${module.id}`}
                                               index={index}>
                                        {(provided) => (

                                            <div
                                                ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                <AdministrationModuleRow moduleData={module}/>
                                            </div>

                                        )}
                                    </Draggable>
                                ))
                            }
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>

        </div>
    );
};

export default AdministrationModuleComponent;